<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="'字段列表（可拖动排序）'">
    <el-tabs :value="activeTab" type="border-card" style="margin-bottom: 20px;">
      <el-tab-pane label="标题字体设置" name="first">
        <FontSetting v-model="titleFont" />
      </el-tab-pane>
      <el-tab-pane label="内容字体设置" name="second">
        <FontSetting v-model="textFont" />
      </el-tab-pane>
      <el-tab-pane label="产品图片设置" name="third">
        <ItemSetting label="图片宽(%）">
          <el-input type="number" placeholder="请输入图片宽度百分比" v-model.number="imageWidth"></el-input>
        </ItemSetting>
      </el-tab-pane>
    </el-tabs>
    <vuedraggable @end="handleDragEnd" v-model="value.data" tag="ul" draggable="li" class="item-list">
      <li class="draggable-item" v-for="(item, index) in value.data" :key="index">
        <ItemSetting :label="item.name" class="item-setting">
          <div class="item-content">
            <span class="key-text">{{ item.key }}</span>
            <el-switch v-model="item.display" @change="handleSwitchChange(index)"></el-switch>
          </div>
        </ItemSetting>
      </li>
    </vuedraggable>
  </EditBox>
</template>

<script>
import vuedraggable from 'vuedraggable'
import EditBox from "./box/EditBox";
import FontSetting from "./setting/FontSetting";
import ItemSetting from "./setting/ItemSetting";
import editMixin from './mixins/editMixin';

export default {
  name: 'ProductEdit',
  mixins: [editMixin],
  components: {
    vuedraggable,
    EditBox,
    FontSetting,
    ItemSetting
  },
  data() {
    return {
      activeTab: 'first'
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleDragEnd() {
      this.updateValue({ data: this.value.data })
    },
    handleSwitchChange(index) {
      this.updateValue({ data: this.value.data })
    }
  },
  computed: {
    titleFont: {
      get() {
        return this.value.titleFont
      },
      set(val) {
        this.updateValue({ titleFont: val })
      }
    },
    textFont: {
      get() {
        return this.value.textFont
      },
      set(val) {
        this.updateValue({ textFont: val })
      }
    },
    imageWidth: {
      get() {
        return this.value.imageWidth
      },
      set(val) {
        this.updateValue({ imageWidth: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.draggable-item {
  padding: 8px 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 8px;

  .item-setting {
    padding: 0;
    margin: 0;

    .item-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .key-text {
        color: #f56c6c;
        font-weight: 600;
      }
    }
  }
}
</style>
